<div class="row row-flex" [ngClass]="maxColsClass">
  <ng-content></ng-content>
</div>
